export default __webpack_public_path__ + "static/media/ProcompLogo_grey.9df341d1.svg";